import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
})
export class RadioComponent implements OnInit {
  @Input('form') form!: UntypedFormGroup;
  @Input('label') label!: string;
  @Input('title') title: string = '';
  @Input('controlName') controlName!: string;
  @Input('value') value!: string | number;
  @Input('disabled') disabled: boolean = false;
  @Input('isDisabled') isDisabled: boolean = false;
  @Input('customClass') customClass: boolean = false;
  @Input('hideRequiredMark') hideRequiredMark: boolean = false;
  required = false;
  validator = Validators.required;

  constructor() {}

  ngOnInit(): void {
    if (this.disabled) this.control?.disable();
    else this.control?.enable();
    if (this.control?.errors?.required === true) this.required = true;
  }

  ngOnChanges(changes: any) {
    if (this.control?.errors?.required === true) this.required = true;
    const disabled = changes?.disabled?.currentValue;
    if (disabled === false){
      this.control.enable();
    } else if (disabled === true){
      this.required = false;
      this.control.disable();
    } 
  }

  get control() {
    return this.form?.controls?.[this.controlName];
  }

  /**
   * Random string of len 5
   * @returns
   */
  private getRandom = () =>
    Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '')
      .substr(0, 5);

  random = this.getRandom();
}
